import { render, staticRenderFns } from "./reportsV1.vue?vue&type=template&id=1850be24"
import script from "./reportsV1.vue?vue&type=script&lang=js"
export * from "./reportsV1.vue?vue&type=script&lang=js"
import style0 from "./reportsV1.vue?vue&type=style&index=0&id=1850be24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports